import React, { useEffect, useState } from "react";
import { Plus, Trash2, Loader2, Upload } from "lucide-react";
import { apiGetAllBanners, apiCreateBanner, apiDeleteBanner, apiUpload, resolveImg } from "../../api";

const emptyBanner = { image: "", eyebrow: "", title: "", subtitle: "", cta: "Shop Now", link: "/collections/perfumes", order: 0, isActive: true };

const AdminBanners = () => {
  const [list, setList] = useState([]);
  const [form, setForm] = useState(emptyBanner);
  const [saving, setSaving] = useState(false);
  const [uploading, setUploading] = useState(false);

  const load = () => apiGetAllBanners().then(setList).catch(() => setList([]));
  useEffect(() => { load(); }, []);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const handleUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const { url } = await apiUpload(file);
      set("image", url);
    } finally {
      setUploading(false);
    }
  };

  const create = async () => {
    if (!form.image) return;
    setSaving(true);
    try {
      await apiCreateBanner({ ...form, order: Number(form.order) });
      setForm(emptyBanner);
      load();
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <h1 className="font-serif text-3xl text-neutral-900 mb-6">Hero Banners</h1>

      <div className="bg-white rounded-sm border border-neutral-200 p-5 mb-6 grid grid-cols-2 gap-3">
        <div className="col-span-2">
          <label className="block text-xs font-medium text-neutral-600 mb-1">Image URL or Upload</label>
          <div className="flex gap-2">
            <input value={form.image} onChange={(e) => set("image", e.target.value)} placeholder="https://..."
              className="flex-1 border border-neutral-300 rounded-sm px-3 py-2 text-sm focus:outline-none focus:border-[#6b0f1a]" />
            <label className="flex items-center gap-1.5 border border-neutral-300 rounded-sm px-3 text-sm cursor-pointer hover:bg-neutral-50">
              {uploading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />}
              <input type="file" accept="image/*" className="hidden" onChange={handleUpload} />
            </label>
          </div>
        </div>
        <input value={form.eyebrow} onChange={(e) => set("eyebrow", e.target.value)} placeholder="Eyebrow"
          className="border border-neutral-300 rounded-sm px-3 py-2 text-sm focus:outline-none focus:border-[#6b0f1a]" />
        <input value={form.title} onChange={(e) => set("title", e.target.value)} placeholder="Title"
          className="border border-neutral-300 rounded-sm px-3 py-2 text-sm focus:outline-none focus:border-[#6b0f1a]" />
        <input value={form.subtitle} onChange={(e) => set("subtitle", e.target.value)} placeholder="Subtitle"
          className="border border-neutral-300 rounded-sm px-3 py-2 text-sm focus:outline-none focus:border-[#6b0f1a]" />
        <input value={form.cta} onChange={(e) => set("cta", e.target.value)} placeholder="CTA text"
          className="border border-neutral-300 rounded-sm px-3 py-2 text-sm focus:outline-none focus:border-[#6b0f1a]" />
        <input value={form.link} onChange={(e) => set("link", e.target.value)} placeholder="/collections/perfumes"
          className="border border-neutral-300 rounded-sm px-3 py-2 text-sm focus:outline-none focus:border-[#6b0f1a]" />
        <input type="number" value={form.order} onChange={(e) => set("order", e.target.value)} placeholder="Order"
          className="border border-neutral-300 rounded-sm px-3 py-2 text-sm focus:outline-none focus:border-[#6b0f1a]" />
        <div className="col-span-2">
          <button onClick={create} disabled={saving} className="flex items-center gap-2 bg-[#6b0f1a] text-[#e9c977] px-4 py-2 text-sm font-medium rounded-sm hover:bg-[#560b15] disabled:opacity-60">
            {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Plus className="h-4 w-4" />} Add Banner
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {list.map((b) => (
          <div key={b.id} className="bg-white rounded-sm border border-neutral-200 overflow-hidden">
            <div className="relative h-32">
              <img src={resolveImg(b.image)} alt={b.title} className="h-full w-full object-cover" />
              <button onClick={async () => { await apiDeleteBanner(b.id); load(); }} className="absolute top-2 right-2 h-7 w-7 bg-white/90 rounded-full flex items-center justify-center hover:text-red-600">
                <Trash2 className="h-3.5 w-3.5" />
              </button>
            </div>
            <div className="p-3">
              <p className="text-xs text-[#a8852f] uppercase tracking-wide">{b.eyebrow}</p>
              <p className="font-serif text-lg text-neutral-900">{b.title}</p>
              <p className="text-xs text-neutral-500">Order: {b.order}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminBanners;
